// V4.2.1: Toast utility functions
// Bu dosya, alert() çağrılarını toast'a dönüştürmek için yardımcı fonksiyonlar içerir

/**
 * Alert mesajını toast'a dönüştürür
 * @param {string} message - Mesaj
 * @param {string} type - Toast tipi ('success', 'error', 'warning', 'info')
 * @param {number} duration - Süre (ms), 0 = otomatik kapanmaz
 */
export const showToast = (toast, message, type = 'info', duration = 3000) => {
  if (!toast) {
    // Fallback: toast yoksa alert kullan
    console.warn('Toast context not available, using alert as fallback');
    alert(message);
    return;
  }

  switch (type) {
    case 'success':
      toast.success(message, duration);
      break;
    case 'error':
      toast.error(message, duration);
      break;
    case 'warning':
      toast.warning(message, duration);
      break;
    case 'info':
    default:
      toast.info(message, duration);
      break;
  }
};

/**
 * Alert mesajını otomatik olarak toast tipine çevirir
 * Mesaj içeriğine göre tip belirlenir:
 * - ✅ veya "başarılı" içeriyorsa -> success
 * - ❌ veya "hata" içeriyorsa -> error
 * - ⚠️ veya "uyarı" içeriyorsa -> warning
 * - Diğer -> info
 */
export const alertToToast = (toast, message, duration = 3000) => {
  if (!toast) {
    alert(message);
    return;
  }

  const lowerMessage = message.toLowerCase();
  
  if (message.includes('✅') || lowerMessage.includes('başarı') || lowerMessage.includes('başarılı') || lowerMessage.includes('tamamlandı')) {
    showToast(toast, message, 'success', duration);
  } else if (message.includes('❌') || lowerMessage.includes('hata') || lowerMessage.includes('başarısız')) {
    showToast(toast, message, 'error', duration);
  } else if (message.includes('⚠️') || lowerMessage.includes('uyarı') || lowerMessage.includes('dikkat')) {
    showToast(toast, message, 'warning', duration);
  } else {
    showToast(toast, message, 'info', duration);
  }
};

/**
 * Confirm dialog'u toast ile değiştirmez (confirm farklı bir şey)
 * Ama confirm sonucunu toast ile gösterebiliriz
 */
export const confirmWithToast = (toast, message, onConfirm, onCancel) => {
  const result = window.confirm(message);
  if (result) {
    if (onConfirm) onConfirm();
  } else {
    if (onCancel) onCancel();
  }
  return result;
};

